{
  "title": "Signaturvorlagen",
  "subtitle": "Eine Vorlage ist ein Signaturdesign; Regeln entscheiden, wer welche erhält.",
  "templates": "Vorlagen",
  "newTemplate": "Neue Vorlage",
  "loadError": "Vorlagen konnten nicht geladen werden",
  "loadTemplateError": "Vorlage konnte nicht geladen werden",
  "emptyTitle": "Noch keine Vorlagen",
  "emptyBody": "Eine Vorlage ist die HTML-Signatur auf ausgehender Mail. Legen Sie eine an, um den Designer zu öffnen.",
  "save": "Speichern",
  "publish": "Veröffentlichen",
  "publishHint": "Kompiliert dieses Design und stellt es für ausgehende Mail bereit. Speichern allein ändert nicht, was Empfänger sehen.",
  "published": "Als v{{version}} veröffentlicht. Signaturen aktualisieren sich innerhalb weniger Sekunden.",
  "publishFailed": "Veröffentlichen fehlgeschlagen.",
  "preview": "Vorschau",
  "undo": "Rückgängig",
  "redo": "Wiederholen",
  "export": "Exportieren",
  "exportHint": "Laden Sie dieses Design als JSON herunter, um es in eine andere Vorlage oder Organisation zu importieren.",
  "exported": "Vorlage exportiert.",
  "import": "Importieren",
  "importHint": "Ersetzt die Leinwand durch ein exportiertes Design. Speichern, um es zu behalten.",
  "imported": "Design importiert. Speichern, um es zu behalten.",
  "importFailed": "Diese Datei ist keine gültige Signaturvorlage.",
  "clone": "Klonen",
  "cloneHint": "Erstellt eine Kopie dieser Vorlage mit dem aktuellen Design.",
  "cloned": "Vorlage geklont.",
  "cloneFailed": "Vorlage konnte nicht geklont werden.",
  "cloneNameSuffix": " (Kopie)",
  "palette": "Blöcke",
  "inspector": "Inspektor",
  "canvas": "Leinwand",
  "unsaved": "Ungespeicherte Änderungen",
  "unsavedShort": "Ungespeichert",
  "checking": "Prüfen…",
  "saved": "Vorlage gespeichert.",
  "saveError": "Vorlage konnte nicht gespeichert werden.",
  "saveFailed": "Speichern fehlgeschlagen.",
  "statusDraft": "Entwurf",
  "statusPublished": "Veröffentlicht",
  "statusArchived": "Archiviert",
  "createTitle": "Neue Vorlage",
  "templateName": "Vorlagenname",
  "templateNamePlaceholder": "Corporate — vollständig",
  "create": "Erstellen",
  "createError": "Vorlage konnte nicht erstellt werden",
  "blockRow": "Zeile",
  "blockColumn": "Spalte",
  "blockText": "Text",
  "blockImage": "Bild",
  "blockSpacer": "Abstand",
  "blockDivider": "Trennlinie",
  "blockSocial": "Social-Icons",
  "blockBanner": "Banner-Platzhalter",
  "blockButton": "Schaltfläche",
  "blockDisclaimer": "Haftungsausschluss",
  "blockGeneric": "Block",
  "addRow": "Zeile hinzufügen",
  "twoColumns": "Zwei Spalten",
  "threeColumns": "Drei Spalten",
  "paletteHelp": "Spalten werden im Inspektor der Zeile hinzugefügt und skaliert. Zeilen können nicht in eine Spalte — verschachtelte Tabellen sind der Punkt, an dem Outlook bricht.",
  "deleteBlock": "Block löschen",
  "duplicateBlock": "Block duplizieren",
  "noSelection": "Block wählen, um Eigenschaften zu bearbeiten.",
  "content": "Inhalt",
  "style": "Stil",
  "layout": "Layout",
  "previewTitle": "Vorschau",
  "previewAs": "Vorschau als",
  "previewNamed": "Vorschau — {{name}}",
  "previewSignature": "Signaturvorschau",
  "closePreview": "Vorschau schließen",
  "compilerWarnings_one": "{{count}} Compiler-Warnung",
  "compilerWarnings_other": "{{count}} Compiler-Warnungen",
  "compilerWarningsHint": "Vom selben Compiler wie beim Veröffentlichen. Blöcke mit Warnung sind auf der Leinwand markiert.",
  "sketchBadge": "Skizze",
  "sketchHint": "Nur Layout — Abstände, Schriften und Outlook-Eigenheiten werden hier nicht nachgebildet. Öffnen Sie die Vorschau für das echte Erscheinungsbild.",
  "canvasEmpty": "Ziehen Sie einen Block aus der Palette oder klicken Sie einen, um ihn hinzuzufügen.",
  "emptyColumn": "Leere Spalte",
  "reorderRow": "Zeile neu anordnen",
  "reorderBlock": "{{block}} neu anordnen",
  "markerExternalOnly": "nur extern",
  "markerNewMessagesOnly": "nur neue Nachrichten",
  "markerConditions_one": "{{count}} Bedingung",
  "markerConditions_other": "{{count}} Bedingungen",
  "placeholderImageNoSource": "Bild — keine Quelle",
  "placeholderImageMerge": "Bild — Quelle mit Serienfeld",
  "placeholderSocialEmpty": "Social-Icons — keine hinzugefügt",
  "placeholderBanner": "Kampagnenbanner — Motiv kommt zur Sendezeit aus der aktiven Kampagne",
  "sampleProfilePhotoAlt": "Beispiel-Profilfoto",
  "sampleProfilePhotoTitle": "Beispiel-Profilfoto — zur Sendezeit wird das echte Foto jedes Absenders verwendet",
  "theme": "Thema",
  "themeHint": "Gilt für die gesamte Signatur. Nur websichere Schriften — Outlook lädt keine Webfonts und Gmail entfernt sie, daher sieht eine Signatur mit eigener Schrift für die meisten Empfänger anders aus.",
  "appliesTo": "Gilt für",
  "font": "Schriftart",
  "baseSizePx": "Basisgröße (px)",
  "textColour": "Textfarbe",
  "linkColour": "Linkfarbe",
  "background": "Hintergrund",
  "backgroundHint": "Meist besser leer lassen. Dark-Mode-Clients färben helle Flächen um — so wird eine Signatur in einem dunklen Thread zur weißen Box.",
  "clearBackground": "Hintergrund entfernen",
  "maxWidthPx": "Maximale Breite (px)",
  "maxWidthPxHint": "Leer lassen für Auto — die Signaturtabelle wird nicht begrenzt.",
  "maxWidthBannerHint": "Leer lassen für Auto — das Banner skaliert auf die Signaturbreite.",
  "hideWhenNoPhoto": "Ausblenden, wenn der Absender kein Foto hat",
  "hideWhenBlank": "Ausblenden, wenn die Felder leer sind",
  "hideWhenNoPhotoHint": "Profilfotos lassen Porträt (und Spalte) weg, wenn das Verzeichnis keines hat — ein leerer Gesichtsplatz ist nie sinnvoll.",
  "hideWhenBlankHint": "Verhindert, dass Nutzer ohne Mobilnummer mit einem verwaisten „M:“ und einem losen Trenner enden.",
  "includeInReplies": "In Antworten und Weiterleitungen einbeziehen",
  "includeInRepliesHint": "Für Logos und Haftungsausschlüsse ausschalten — ab der vierten Nachricht im Thread werden sie zu Rauschen.",
  "recipients": "Empfänger",
  "audienceEveryone": "Alle",
  "audienceExternalOnly": "Nur extern",
  "showOnlyWhen": "Nur anzeigen wenn",
  "visibleWhenEmptyHint": "Immer sichtbar. Bedingung hinzufügen, um diesen Block auf bestimmte Nutzer zu beschränken.",
  "alignment": "Ausrichtung",
  "alignLeft": "Links",
  "alignCentre": "Mitte",
  "alignRight": "Rechts",
  "paddingTop": "Abstand oben",
  "paddingBottom": "Abstand unten",
  "columns": "Spalten",
  "columnsHint": "Spalten werden hier hinzugefügt und entfernt statt gezogen, weil eine Spalte nur in ihrer Zeile Sinn ergibt.",
  "columnWidth": "Breite Spalte {{n}}",
  "placeholderAuto": "Auto",
  "placeholderTheme": "Thema",
  "removeColumn": "Spalte {{n}} entfernen",
  "editColumn": "Bearbeiten",
  "addColumn": "Spalte hinzufügen",
  "widthPx": "Breite (px)",
  "widthPxHint": "Leer gelassen teilt die Spalte den Restplatz. Feste Breiten überstehen die Word-Engine besser als Prozentwerte.",
  "verticalAlign": "Vertikale Ausrichtung",
  "alignTop": "Oben",
  "alignMiddle": "Mitte",
  "alignBottom": "Unten",
  "padLeft": "Abstand links",
  "padRight": "Abstand rechts",
  "padTop": "Abstand oben",
  "padBottom": "Abstand unten",
  "text": "Text",
  "sizePx": "Größe (px)",
  "lineHeight": "Zeilenhöhe",
  "colour": "Farbe",
  "bold": "Fett",
  "italic": "Kursiv",
  "link": "Link",
  "disclaimerText": "Text des Haftungsausschlusses",
  "imageUrl": "Bild-URL",
  "imageUrlHint": "Absolute HTTPS-URL oder {{photoToken}} für das Verzeichnisfoto jedes Absenders. Gmail rendert keine eingebettete Anlage — Bilder werden immer gehostet.",
  "useProfilePhoto": "Profilfoto verwenden",
  "chooseFromLibrary": "Aus Bibliothek wählen",
  "clear": "Löschen",
  "profilePhotoHint": "Zur Sendezeit wird daraus das Foto des Absenders. Ohne Foto entfallen Porträt und Spalte vollständig — nie ein kaputtes Bild oder eine leere Gesichtsfläche.",
  "heightPx": "Höhe (px)",
  "unlockAspect": "Seitenverhältnis entsperren",
  "lockAspect": "Seitenverhältnis sperren",
  "autoSize": "Auto",
  "autoProfileHint": "Setzt {{size}}×{{size}} für den Porträtplatz.",
  "autoNaturalHint": "Nutzt die natürliche Bildgröße (für Signaturen begrenzt).",
  "autoNeedSource": "Zuerst eine Bild-URL hinzufügen oder eines aus der Bibliothek wählen.",
  "autoNeedHttps": "Auto benötigt eine https://-Bild-URL zum Messen.",
  "autoMeasureFailed": "Bildgröße konnte nicht gelesen werden. Prüfen Sie, ob die URL im Browser lädt.",
  "aspectLocked": "Seitenverhältnis gesperrt — eine Seite skaliert die andere.",
  "aspectUnlocked": "Seitenverhältnis entsperrt — Breite und Höhe unabhängig.",
  "dimensionsHint": "Beide Maße werden als HTML-Attribute ausgegeben. Fehlen sie, skaliert die Word-Engine das Bild auf Displays über 96 DPI — also den meisten.",
  "altText": "Alt-Text",
  "profilePhotoAlt": "Profilfoto",
  "frame": "Rahmen",
  "frameHint": "Ränder und weiche Schatten erscheinen in modernen Clients. Klassisches Outlook behält den Rand und ignoriert Radius und Schatten.",
  "frameColour": "Rahmenfarbe",
  "frameNone": "Keiner",
  "frameThin": "Dünn",
  "frameThick": "Dick",
  "frameRounded": "Abgerundet",
  "frameCircle": "Kreis",
  "frameSoftShadow": "Weicher Schatten",
  "effect": "Effekt",
  "effectHint": "Erzeugt ein e-mail-sicheres animiertes GIF. Outlook Desktop friert oft auf dem fertigen Standbild ein; Gmail und andere spielen die Motion ab.",
  "effectProfileHint": "Effekte brauchen ein gehostetes Bibliotheksbild oder eine HTTPS-URL — kein Profilfoto-Merge-Feld.",
  "effectNeedHttps": "Fügen Sie zuerst ein https://-Bild hinzu oder wählen Sie eines aus der Bibliothek.",
  "effectConverting": "Wird in ein animiertes GIF umgewandelt…",
  "effectApplyFailed": "Dieser Effekt konnte nicht angewendet werden.",
  "effectNone": "Kein Effekt",
  "effectWhipFlip": "Whip Flip",
  "effectDottedGloom": "Dotted Gloom",
  "effectGlowSway": "Glow Sway",
  "effectInvertedChaos": "Inverted Chaos",
  "effectHaloBlur": "Halo Blur",
  "effectBlur": "Blur",
  "effectMirror": "Mirror",
  "effectFadeOut": "Fade Out",
  "effectLowExposure": "Low Exposure",
  "effectColorsOff": "Colors Off",
  "networkPlaceholder": "Netzwerk",
  "removeIcon": "{{name}} entfernen",
  "iconFallback": "Icon",
  "profileUrl": "Profil-URL",
  "profileUrlPlaceholder": "Profil-URL — darf ein Serienfeld sein",
  "iconImageUrl": "Icon-Bild-URL",
  "iconImageUrlPlaceholder": "Icon-Bild-URL",
  "addIcon": "Icon hinzufügen",
  "socialIconsHint": "Ein Icon mit leerem Link fällt von selbst weg — Nutzer ohne LinkedIn bekommen kein totes Icon.",
  "platformLabel": "Plattform",
  "platformLinkedIn": "LinkedIn",
  "platformX": "X",
  "platformFacebook": "Facebook",
  "platformInstagram": "Instagram",
  "platformYouTube": "YouTube",
  "platformTikTok": "TikTok",
  "platformThreads": "Threads",
  "platformGitHub": "GitHub",
  "platformWhatsApp": "WhatsApp",
  "platformWebsite": "Website",
  "platformOther": "Sonstiges",
  "chooseIconFromLibrary": "Icon aus Bibliothek wählen",
  "useDefaultIcon": "Standard-Icon verwenden",
  "iconOverrideHint": "Nur bei Sonstiges ohne Bild leer lassen. Standard-Icons sind HTTPS-URLs des Produkts.",
  "iconAlt": "Alt-Text",
  "moveIconUp": "Icon nach links",
  "moveIconDown": "Icon nach rechts",
  "iconMustBeHttps": "Das Icon-Bild braucht eine https://-URL, damit es in Mails erscheint.",
  "spacingPx": "Abstand (px)",
  "bannerSlotHint": "Motiv und Link kommen von der Kampagne, die beim Senden aktiv ist — Marketing kann Banner starten und beenden, ohne diese Vorlage zu öffnen.",
  "label": "Beschriftung",
  "url": "URL",
  "buttonWidth": "Breite",
  "buttonHeight": "Höhe",
  "cornerRadius": "Eckenradius",
  "fontSize": "Schriftgröße",
  "thicknessPx": "Stärke (px)",
  "dividerHint": "Als gefüllte Tabellenzelle statt hr — Clients stylen hr inkonsistent.",
  "insertField": "Feld einfügen",
  "searchFields": "Felder suchen",
  "noFieldMatch": "Kein Feld passt dazu.",
  "mergeFieldProblem": "Problem mit Serienfeld",
  "emptyText": "Leerer Text",
  "groupThisTenant": "Dieser Mandant",
  "groupUser": "Benutzer",
  "groupOrganisation": "Organisation",
  "groupCampaign": "Kampagne",
  "fieldDisplayName": "Anzeigename",
  "fieldGivenName": "Vorname",
  "fieldSurname": "Nachname",
  "fieldJobTitle": "Position",
  "fieldDepartment": "Abteilung",
  "fieldPrimaryEmail": "E-Mail-Adresse",
  "fieldPhotoUrl": "Profilfoto (Bild-URL)",
  "fieldMobilePhone": "Mobil",
  "fieldBusinessPhone": "Telefon",
  "fieldOfficeLocation": "Büro",
  "fieldCity": "Stadt",
  "fieldCountry": "Land",
  "fieldTenantName": "Organisationsname",
  "fieldTenantSlug": "Organisations-Slug",
  "fieldCampaignAlt": "Banner-Alt-Text",
  "fieldCampaignUrl": "Banner-Link",
  "dirtyPreviewTitle": "Letzte gespeicherte Version",
  "dirtyPreviewBody": "Die Vorschau zeigt das Gespeicherte, nicht die Leinwand. Speichern zum Aktualisieren.",
  "desktopWidth": "Desktop 600px",
  "mobileWidth": "Mobil 320px",
  "darkMode": "Dunkelmodus",
  "darkModeTooltip": "Nur Annäherung: Farben werden invertiert und gedreht — kein echter Client tut das. Outlook, Gmail und Apple Mail färben unterschiedlich um; manche lassen helle Hintergründe. Nutzen Sie es, um verschwindende Signaturen zu finden, nicht um Farben freizugeben.",
  "darkModeHint": "Annähernd. Echte Clients färben anders — als Rauchtest, nicht als Beweis.",
  "renderWarnings": "Render-Warnungen",
  "renderError": "Vorschau konnte nicht gerendert werden",
  "iframeTitle": "Signaturvorschau — {{context}}",
  "contextNew": "Neu",
  "contextReply": "Antwort",
  "contextNewExternal": "Neu (extern)",
  "contextReplyExternal": "Antwort (extern)",
  "contextGmail": "Gmail",
  "contextAddIn": "Add-In",
  "contextPlainText": "Nur-Text",
  "testAs": "Testen als",
  "testAsHint": "Serienfelder und Foto stammen aus diesem Postfach. Leeren für die Beispielperson.",
  "loadingMailboxes": "Postfächer werden geladen…",
  "samplePerson": "Beispielperson",
  "noMailboxMatch": "Kein Postfach passt zur Suche.",
  "selectedMailbox": "Ausgewähltes Postfach",
  "excludedSuffix": " (ausgeschlossen)",
  "gmailBudget": "Gmail-Größenbudget",
  "gmailCharacters": "{{used}} / {{max}} Zeichen",
  "gmailWillTruncate": "Gmail kürzt ab",
  "gmailNearLimit": "Nahe am Limit",
  "assetPickerTitle": "Bild wählen",
  "assetPickerHint": "Gehostete Bilder, die der Empfänger-Client abruft. PNG, JPEG, GIF oder WebP.",
  "uploadImage": "Bild hochladen",
  "uploadWarningTitle": "Hochgeladen, aber prüfenswert",
  "assetsEmpty": "Noch keine Bilder. Laden Sie eines hoch — es erscheint hier für jede Signatur dieses Mandanten.",
  "alreadyInLibrary": "Dieses Bild war schon in der Bibliothek, daher wurde das vorhandene verwendet.",
  "uploadFailed": "Dieses Bild konnte nicht hochgeladen werden.",
  "deleteFailedTitle": "Nicht gelöscht",
  "deleteFailed": "Dieses Bild konnte nicht gelöscht werden.",
  "deleteAsset": "{{name}} löschen",
  "useThisAsset": "Dieses verwenden"
}
